import {useEffect} from 'react'
import {CLICKABLE_SELECTOR, TRACKING_ATTRIBUTES} from '../../constants'

const getAttr = (el, name) => (el && el.getAttribute ? el.getAttribute(name) : null)

const hasTrackingAttributes = (el) => TRACKING_ATTRIBUTES.some((attr) => el.hasAttribute(attr))

const toPromotionId = (promotionName) =>
    promotionName ? promotionName.replace(/[\s-]+/g, '_') : undefined

const pushContentClick = (anchor) => {
    if (typeof window === 'undefined') return
    const promotionName = getAttr(anchor, 'data-promotion-name') || undefined
    const dataLayer = (window.dataLayer = window.dataLayer || [])
    dataLayer.push({ecommerce: null})
    dataLayer.push({
        event: 'content_click',
        ecommerce: {
            creative_name: getAttr(anchor, 'data-creative-name') || undefined,
            creative_slot: getAttr(anchor, 'data-creative-slot') || undefined,
            promotion_name: promotionName,
            promotion_id: getAttr(anchor, 'data-promotion-id') || toPromotionId(promotionName)
        }
    })
}

const handleContentInteraction = (event) => {
    if (event.type === 'auxclick' && event.button !== 1) {
        return
    }
    const {target} = event
    if (!target || !target.closest) {
        return
    }
    const anchor = target.closest(CLICKABLE_SELECTOR)
    if (!anchor || !hasTrackingAttributes(anchor)) {
        return
    }
    pushContentClick(anchor)
}

const useContentClickTracking = () => {
    useEffect(() => {
        if (typeof document === 'undefined') return
        document.addEventListener('click', handleContentInteraction)
        document.addEventListener('auxclick', handleContentInteraction)
        document.addEventListener('contextmenu', handleContentInteraction)
        return () => {
            document.removeEventListener('click', handleContentInteraction)
            document.removeEventListener('auxclick', handleContentInteraction)
            document.removeEventListener('contextmenu', handleContentInteraction)
        }
    }, [])
}

export default useContentClickTracking
